import React from 'react';
import { motion } from 'framer-motion';
import { Search, DollarSign, Wrench, Shield, TrendingUp } from 'lucide-react';
const services = [{
  icon: Search,
  title: 'Risk Assessment & Profiling',
  description: 'Comprehensive analysis of your risk exposure to identify vulnerabilities and develop tailored protection strategies.'
}, {
  icon: DollarSign,
  title: 'Premium Negotiation & Placement of Cover',
  description: 'Leveraging our market expertise to secure competitive rates and optimal coverage terms from leading insurers.'
}, {
  icon: Wrench,
  title: 'Product Design & Customization',
  description: 'Creating bespoke insurance solutions that align perfectly with your unique business needs and risk profile.'
}, {
  icon: Shield,
  title: 'Claims Management & Advocacy',
  description: 'Expert guidance through the claims process, ensuring swift resolution and maximum settlement for your claims.'
}, {
  icon: TrendingUp,
  title: 'Risk Management Advisory',
  description: 'Strategic consulting to minimize risk exposure, improve safety protocols, and optimize your insurance portfolio.'
}];
export function CoreServices() {
  return <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white" data-id="element-153">
      <div className="container mx-auto px-4 md:px-6" data-id="element-154">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-155">
          <p className="text-sm font-medium text-brand-red uppercase tracking-wider mb-4" data-id="element-156">
            Our Expertise
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-brand-black max-w-4xl mx-auto leading-tight" data-id="element-157">
            Core Services <span className="text-brand-red" data-id="element-158">Offerings</span>
          </h2>
        </motion.div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto" data-id="element-159">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} whileHover={{
          y: -8,
          transition: {
            duration: 0.3
          }
        }} className="group relative bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 overflow-hidden" data-id="element-160">
              {/* Subtle gradient overlay on hover */}
              <div className="absolute inset-0 bg-gradient-to-br from-red-50/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-161" />

              <div className="relative z-10" data-id="element-162">
                {/* Icon */}
                <motion.div whileHover={{
              rotate: 360,
              scale: 1.1
            }} transition={{
              duration: 0.6,
              ease: 'easeInOut'
            }} className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-red-500 to-red-600 rounded-2xl mb-6 shadow-lg shadow-red-500/20" data-id="element-163">
                  <service.icon className="w-8 h-8 text-white" strokeWidth={2} data-id="element-164" />
                </motion.div>

                {/* Title */}
                <h3 className="text-xl font-bold text-brand-black mb-3 leading-tight" data-id="element-165">
                  {service.title}
                </h3>

                {/* Description */}
                <p className="text-gray-600 leading-relaxed" data-id="element-166">
                  {service.description}
                </p>

                {/* Decorative element */}
                <div className="absolute bottom-0 right-0 w-32 h-32 bg-gradient-to-br from-red-500/5 to-transparent rounded-tl-full transform translate-x-16 translate-y-16 group-hover:scale-150 transition-transform duration-500" data-id="element-167" />
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}